export const SWITCH_TO_ADMIN_VIEW = 'SWITCH_TO_ADMIN_VIEW';
export const SWITCH_TO_USER_VIEW = 'SWITCH_TO_USER_VIEW';
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const VIEW = {
  USER: 'user',
  ADMIN: 'admin',
};
